import Events from '../events';
import SelectorMapping from '../SelectorMapping';

class RecaptchaObserver {
  static async watch() {
    const googleResultsContainer = document.querySelector(
      '[data-comp-google-search-results]',
    );

    const mutationObserver = new MutationObserver((mutations, observer) => {
      if (document.getElementById('recaptcha-wrapper')) {
        window.dispatchEvent(Events.GoogleRecaptchaPresentEvent);
        observer.disconnect();
      }
    });

    mutationObserver.observe(googleResultsContainer, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }
}

export default RecaptchaObserver;
